import { render, staticRenderFns } from "./asideComponent.vue?vue&type=template&id=596b2cd2&scoped=true"
import script from "./asideComponent.vue?vue&type=script&lang=js"
export * from "./asideComponent.vue?vue&type=script&lang=js"
import style0 from "./asideComponent.vue?vue&type=style&index=0&id=596b2cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596b2cd2",
  null
  
)

export default component.exports